import { cx } from "@/lib/cx";

/** Kasten "K" mark (vector redraw of the supplied brand mark). Inherits currentColor. */
export function KMark({ className, title }: { className?: string; title?: string }) {
  return (
    <svg viewBox="0 0 460 480" className={cx("shrink-0", className)} role={title ? "img" : undefined} aria-hidden={title ? undefined : true} aria-label={title}>
      <path
        fill="currentColor"
        d="M13 30Q13 15 28 15L137 15Q150 15 150 28L150 135L40 280L310 20Q315 15 322 15L415 15Q428 17 420 27L222 232L440 450Q448 464 435 468L352 468Q322 468 300 446L158 308L13 455Z"
      />
    </svg>
  );
}

/** K-SHOP product lockup. */
export function KshopLogo({ className, subtitle = true }: { className?: string; subtitle?: boolean }) {
  return (
    <div className={cx("flex items-center gap-2.5", className)}>
      <span className="flex size-9 items-center justify-center rounded-lg bg-[#0B0C0E] text-white dark:ring-1 dark:ring-white/15">
        <KMark className="size-5" />
      </span>
      <span className="flex flex-col leading-none">
        <span className="text-lg font-semibold tracking-tight text-fg">K-SHOP</span>
        {subtitle && <span className="mt-1 text-xs text-fg-muted">by Kasten Technologies</span>}
      </span>
    </div>
  );
}
